// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2gX7K","inner":"Form_inner__wXE8u","range":"Form_range__10agy","name":"Form_name__3bqN6","actions":"Form_actions__34hkD"};